import React, { useEffect, useRef } from "react";
import "./style/home.css";

//import { Link } from "react-router-dom";

import {
  background,
  feature2,
  feature1,
  feature3,
  whatsapp,
  product1,
  product2,
  product3,
} from "./assets/index";
const Home = () => {
  const productSectionRef = useRef(null);

  const products = [
    {
      src: product1,
      model: "Model A",
      description: "RO",
      mainColumns: [
        "CAPACITY",
        " MEMBRANE ",
        "PUMP",
        "MOC",
        "PIPING",
        "SYSTEM",
      ],
      subColumns: [
        "250-50000 LPH",
        "TOREY/DOW/EQUI V.",
        "GRUNDFOS/KIRLOSKAR/EQUIV.",
        " M.S./S.S.",
        " UPVC/S.S./EQUIV.",
        "MANUAL/AUTO",
      ],
    },
    {
      src: product2,
      model: "Model B",
      description: "UF",
      mainColumns: [
        "CAPACITY",
        " MEMBRANE ",
        "PUMP",
        "MOC",
        "PIPING",
        "SYSTEM",
      ],
      subColumns: [
        "250-50000 LPH",
        "TOREY/DOW/EQUI V.",
        "GRUNDFOS/KIRLOSKAR/EQUIV.",
        " M.S./S.S.",
        " UPVC/S.S./EQUIV.",
        "MANUAL/AUTO",
      ],
    },
    {
      src: product3,
      model: "Model B",
      description: "STPETP",
      mainColumns: [
        "CAPACITY",
        " MEMBRANE ",
        "PUMP",
        "MOC",
        "PIPING",
        "SYSTEM",
      ],
      subColumns: [
        "250-50000 LPH",
        "TOREY/DOW/EQUI V.",
        "GRUNDFOS/KIRLOSKAR/EQUIV.",
        " M.S./S.S.",
        " UPVC/S.S./EQUIV.",
        "MANUAL/AUTO",
      ],
    },
  ];

  const handleWhatsAppChat = () => {
    const phoneNumber = "+91 8511444442"; // Add country code (e.g., +91 for India) and remove spaces
    const message =
      "Hello! I want to inquire about your water filtration products.";
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".product-image-item");
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add("active");
              }, index * 300); // Stagger the animation
            });
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const currentProductSectionRef = productSectionRef.current;
    if (currentProductSectionRef) {
      observer.observe(currentProductSectionRef);
    }

    return () => {
      if (currentProductSectionRef) {
        observer.unobserve(currentProductSectionRef);
      }
    };
  }, []);

  return (
    <div className="home">
      <div className="whatsapp-icon" onClick={handleWhatsAppChat}>
        <img src={whatsapp} alt="WhatsApp" />
      </div>

      <section
        className="hero"
        style={{
          position: "relative",
          top: 20,
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="hero-content">
          <div className="text-container">
            <div className="flex-row">
              <h1>Solution means success</h1>
            </div>
            <p style={{ color: "white" }}>
              Welcome to TECHSOLN ENTERPRISE, where expertise in water and
              wastewater treatment meets a commitment to excellence. We are a
              dedicated team of professionals with a passion for creating
              sustainable solutions to the complex challenges facing water
              management today.
            </p>

            <a href="/Product" className="cta-button">
              Explore Now
            </a>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2>Features</h2>
        <div className="features-list">
          <div className="feature-item1">
            <div className="feature-icon">
              <img src={feature1} alt="Feature2" />
            </div>
            <h3>Waste water treatment plants</h3>
            <p>
              Our plants use advanced technology to efficiently treat
              wastewater, ensuring safe and clean water for reuse or discharge,
              while protecting the environment
            </p>
          </div>
          <div className="feature-item2">
            <div className="feature-icon">
              <img src={feature3} alt="Customizable Solutions" />
            </div>
            <h3>water treatment Plants</h3>
            <p>
              Our water treatment plants utilize cutting-edge technology to
              purify water, ensuring it meets the highest standards for safe and
              clean drinking water
            </p>
          </div>
          <div className="feature-item3">
            <div className="feature-icon">
              <img src={feature2} alt="Customizable Solutions" />
            </div>
            <h3>Chemical & Spares</h3>
            <p>
              We provide high-quality chemicals and durable spares to ensure the
              efficient operation and maintenance of water and wastewater
              treatment plants
            </p>
          </div>
        </div>
      </section>

      {/* Product Images Section */}

      <section className="new-product-gallery" ref={productSectionRef}>
        <div className="new-section-header">
          <h2>NEW PROJECT</h2>
          <button
            className="new-view-all-button"
            onClick={() => (window.location.href = "/product")}
          >
            View All
          </button>
        </div>
        <div className="new-product-list">
          {products.map((product, index) => (
            <div
              className="new-product-item"
              key={index}
              style={{ "--animation-order": index }}
            >
              <img src={product.src} alt={`Product ${product.model}`} />
              <h3>{product.description}</h3>
              <div className="new-columns-container">
                {/* Main Column */}
                <div className="new-main-column">
                  {product.mainColumns.map((mainCol, i) => (
                    <h6 key={`main-${i}`}>{mainCol}</h6>
                  ))}
                </div>
                {/* Sub Column */}
                <div className="new-sub-column">
                  {product.subColumns.map((subCol, i) => (
                    <h6 key={`sub-${i}`}>{subCol}</h6>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* <section className="product-images" ref={productSectionRef}>
        <h2>NEW PROJECT</h2>
        <div className="product-images-list">
          {[Product1, Product2, Product3].map((src, index) => (
            <div
              className="product-image-item"
              key={index}
              style={{ "--animation-order": index }}
            >
              <img src={src} alt={`Product ${index + 1}`} />
              <p>
                Water Filter System - Model {String.fromCharCode(65 + index)}
              </p>
            </div>
          ))}
        </div>
      </section> */}

      {/* CEO Section */}
      <section className="ceo-message">
        <h2>Message from Our CEO</h2>
        <div className="ceo-content">
          <img src="path/to/ceo.jpg" alt="CEO" className="ceo-image" />
          <p>
            At Techsoln, we are committed to delivering innovative
            solutions for water treatment through our advanced plants, premium
            chemicals, and reliable spares. Our mission is to ensure sustainable
            water management and contribute to a healthier, cleaner environment.
          </p>
          <p>BHAVIK BRAHMBHATT</p>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <h2>What Our Customers Say</h2>
        <div className="testimonial-item">
          <p>
            "The filtration system we purchased has exceeded our expectations.
            Highly recommended!"
          </p>
          <p>- Customer Name</p>
        </div>
        <div className="testimonial-item">
          <p>
            "Great product quality and excellent customer service. Thank you,
            Vishwakarma Enterprises!"
          </p>
          <p>- Customer Name</p>
        </div>
      </section>

      {/* Call to Action Section */}
      {/* <section className="call-to-action">
        <h2>Ready to Enjoy Clean Water?</h2>
        <p>
          Experience the benefits of our advanced water filtration systems
          today.
        </p>
        <Link to="/Product" className="cta-button">
          Explore Now
        </Link>
      </section> */}

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-left">
            <h3>Techsoln</h3>
            <p>
              Your trusted partner in water filtration solutions. Providing
              customized, advanced water filtration systems since 2017.
            </p>
            <div className="social-links">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="footer-middle">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/About">About Us</a>
              </li>
              <li>
                <a href="/Product">Products</a>
              </li>
            </ul>
          </div>

          <div className="footer-right">
            <h4>Contact Us</h4>
            <p>
              <strong>Email:</strong> info@techsoln.co.in
            </p>
            <p>
              <strong>Phone:</strong> +91 85114 44442
            </p>
            <p>
              <strong>Address:</strong> TF-325, “S9 SQUARE”, Opp. Lotus Aura,
              Sama-Savli Road, Vadodara 390008, Gujarat, India
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Techsoln. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
